/**
 * Sdílené enumy — zrcadlí enumy v apps/api/prisma/schema.prisma.
 * Zdroj pravdy: podklady/05-knowledge-graph.md (KG v2).
 * Hodnoty = snake_case stringy shodné s Prisma enumy (drátový formát API).
 */
/** Stav zakázky (KG §3 Zakázka) — život nekončí předáním, proto stav `zaruka`. */
export const ZAKAZKA_STAVY = ['priprava', 'realizace', 'predano', 'zaruka', 'uzavreno'];
/** Typ smlouvy (KG §3 Smlouva) — 1 hlavní SOD + N subdodavatelských na zakázku. */
export const SMLOUVA_TYPY = ['hlavni', 'subdodavatelska'];
/** Režim DPH (finance-vcp §8) — stavební práce mezi plátci = přenesená daňová povinnost § 92e. */
export const REZIMY_DPH = ['prenesena_danova_povinnost', 'standardni'];
/**
 * Stav Změny/vícepráce (KG §3 Změna, sjednoceno s wireframy 13 §3–4):
 * nová → kvalifikovaná → oceněná → schválená → v dodatku → fakturovatelná;
 * větve `zamitnuta` a `sporna` (claim). Nález NENÍ stav Změny — je samostatná entita Nalez.
 */
export const ZMENA_STAVY = [
    'nova',
    'kvalifikovana',
    'ocenena',
    'schvalena',
    'v_dodatku',
    'fakturovatelna',
    'zamitnuta',
    'sporna',
];
/** Zdroj nálezu/podnětu (workflow-viceprace §1) — změna se rodí na víc místech než v terénu. */
export const NALEZ_ZDROJE = ['teren', 'revize_pd', 'pozadavek_investora', 'fakturace'];
/** Stav nálezu (wireframe 13 §2): nový → kvalifikován / zamítnut (s důvodem) / sloučeno. */
export const NALEZ_STAVY = ['novy', 'kvalifikovan', 'zamitnut', 'slouceno'];
/** Směr Změnového listu (invariant 4: výnosový ZL k hlavní SOD, nákladový k subsmlouvě). */
export const ZL_SMERY = ['vynos', 'naklad'];
/**
 * Typ ocenění ZL (KG §3 ZL; 07 §9; workflow-viceprace §5): v rozpočtu → jednotková cena
 * ze SOD, mimo → CN s rozpadem; vlastní provedení GD → vlastní kalkulace; ostatní → ruční náklad.
 */
export const ZL_OCENENI_TYPY = [
    'sod_jednotkova_cena',
    'cn_s_rozpadem',
    'vlastni_kalkulace',
    'rucni_naklad',
];
/** Typy ocenění nákladového ZL, které NEMAJÍ smlouvu (vlastní provedení / ruční náklad). */
export const ZL_OCENENI_BEZ_SMLOUVY = ['vlastni_kalkulace', 'rucni_naklad'];
/**
 * Pravidlo smlouvy na ZL (zrcadlí /// komentář u modelu ZmenovyList):
 * výnosový ZL MUSÍ mít smlouvu (hlavní SOD); nákladový má buď subsmlouvu,
 * nebo je bez smlouvy s oceněním `vlastni_kalkulace` / `rucni_naklad`.
 */
export function zlVyzadujeSmlouvu(smer, oceneniTyp) {
    if (smer === 'vynos')
        return true;
    return !ZL_OCENENI_BEZ_SMLOUVY.includes(oceneniTyp);
}
/** Stav ZL (KG §3 ZL + korekce dozoru: `provedeno_na_riziko` a `sporne` jsou realita praxe). */
export const ZL_STAVY = [
    'navrzeno',
    'podepsano',
    'zamitnuto',
    'provedeno_na_riziko',
    'sporne',
];
/** Spouštěč tranše pozastávky (KG §3 Pozastávka) — konfigurovatelné per smlouva, ne hardcode. */
export const TRANSE_SPOUSTECE = [
    'predani_dila',
    'odstraneni_vad_a_nedodelku',
    'konec_zaruky',
    'rucni',
];
/** Stav tranše pozastávky (auto-uvolňování = fáze 2, evidence = MVP). */
export const TRANSE_STAVY = [
    'ceka',
    'uvolnitelna',
    'uvolnena',
    'nahrazena_bankovni_zarukou',
];
/** Stav zjišťovacího protokolu (KG §3 ProgressStatement): navrženo → odsouhlaseno (TDI / GD). */
export const ZJISTOVACI_PROTOKOL_STAVY = ['navrzeno', 'odsouhlaseno'];
/** Typ předávacího protokolu (KG §3 HandoverProtocol). */
export const PREDAVACI_PROTOKOL_TYPY = ['subdodavatel_gd', 'gd_objednatel'];
/** Typ deníku (KG §3 DiaryEntry) — stavební (GD) a montážní (subka) běží paralelně. */
export const DENIK_TYPY = ['stavebni', 'montazni'];
/** Stav úkolu (KG §3 Task) — jednoduché stavy, žádný workflow engine v MVP. */
export const UKOL_STAVY = ['novy', 'probiha', 'hotovo', 'zamitnuto'];
/** Stav vady (KG §3 Defect) — zavírá vždy GD (v záruce reklamační technik). */
export const VADA_STAVY = ['otevreno', 'opraveno', 'prekontrolovano'];
/** Fáze vzniku vady (KG §3 Defect, korekce dozoru — levné teď, nedolepitelné později). */
export const VADA_FAZE_VZNIKU = [
    'prubezna',
    'prejimka_subdodavky',
    'predani_objednateli',
    'zaruka',
];
/** Stav výzvy/schválení (KG §3 Approval): vyzváno → vyjádřeno → schváleno/zamítnuto. */
export const VYZVA_STAVY = ['vyzvano', 'vyjadreno', 'schvaleno', 'zamitnuto'];
/** Předmět výzvy (polymorfní vazba — jeden mechanismus pro přejímku TDI i schválení ZL). */
export const VYZVA_PREDMETY = [
    'zmenovy_list',
    'denik_zaznam',
    'vada',
    'zjistovaci_protokol',
    'prejimka',
];
/**
 * Entita, na kterou se váže příloha (polymorfní vazba, KG §3 Foto/Příloha).
 * `nalez` — foto/audio z terénu se věší na Nalez (důkaz, read-only).
 */
export const PRILOHA_ENTITY = [
    'denik_zaznam',
    'ukol',
    'vada',
    'nalez',
    'zmena',
    'zmenovy_list',
    'zakazka',
];
/** Kategorie nákladové položky (KG §3 CostItem). */
export const COST_KATEGORIE = ['prace', 'material', 'technika', 'subdodavka', 'rezie'];
/**
 * Akce auditní stopy (append-only log; invariant 2: podpis = zámek).
 * `unlock` NIKDY neplatí pro podepsaný DenikZaznam, podepsaný ZL ani udělené schválení
 * (trvalá neměnnost) — jen pro budoucí administrativní entity.
 */
export const AUDIT_AKCE = [
    'create',
    'update',
    'delete',
    'sign',
    'lock',
    'unlock',
    'login',
    'logout',
    // Samoobslužné založení firmy (POST /api/registrace) — první záznam auditu firmy.
    'registrace',
];
/**
 * Výchozí sada rolí (KG §3 Role; §0b — šablona, firmy si role přejmenují/doplní;
 * zeď kolem marží zůstává invariant vynucený na API, ne názvem role).
 */
export const VYCHOZI_ROLE = [
    'reditel',
    'pripravar',
    'stavbyvedouci',
    'mistr',
    'tdi',
    'reklamacni_technik',
    'subdodavatel',
    'investor',
];
//# sourceMappingURL=enums.js.map